/* eslint-disable @typescript-eslint/no-explicit-any */
import { Text, Th, Thead, Tr, VStack, HStack } from "@chakra-ui/react";
import SortButton from './SortButton';

const HeaderTable = ({
  children,
  sortOrder,
  setSortOrder,
  clientsSortOrder,
  setClientsSortOrder,
  grouping,
}: {
  children: React.ReactNode;
  sortOrder?: 'asc' | 'desc' | null;
  setSortOrder?: (order: 'asc' | 'desc' | null) => void;
  clientsSortOrder?: 'asc' | 'desc' | null;
  setClientsSortOrder?: (order: 'asc' | 'desc' | null) => void;
  grouping?: {
    bibliotecaDigital?: number;
    bancaRevistas?: number;
    svas?: number;
  };
}) => {
  const hasGrouping =
    grouping &&
    (Number(grouping.bibliotecaDigital) > 0 ||
      Number(grouping.bancaRevistas) > 0 ||
      Number(grouping.svas) > 0);

  return (
    <Thead position="sticky" top={0} bg="white" zIndex={10} boxShadow="0 2px 4px rgba(0,0,0,0.1)">
      {hasGrouping ? (
        <Tr borderBottom="0px solid" borderColor="gray.200" bg="gray.50">
          {/* Fixed columns spacers */}
          <Th width="60px" bg="gray.50" />
          <Th width="300px" bg="gray.50" />
          <Th width="120px" bg="gray.50" />
          <Th width="80px" bg="gray.50" />

          {grouping.bibliotecaDigital ? (
            <Th
              colSpan={grouping.bibliotecaDigital}
              textAlign="center"
              fontSize="xs"
              fontWeight="extrabold"
              color="gray.700"
              minW="200px"
              maxW="200px"
              flexWrap="nowrap"
              overflow="hidden"
              textTransform="uppercase"
              bg="gray.50"
            >
              Biblioteca digital
            </Th>
          ) : null}

          {grouping.bancaRevistas ? (
            <Th
              colSpan={grouping.bancaRevistas}
              textAlign="center"
              fontSize="xs"
              minW="200px"
              maxW="200px"
              fontWeight="extrabold"
              flexWrap="nowrap"
              overflow="hidden"
              color="gray.700"
              textTransform="uppercase"
              bg="gray.50"
            >
              Banca e revistas digitais de descontos (clube)
            </Th>
          ) : null}

          {grouping.svas ? (
            <Th
              colSpan={grouping.svas}
              textAlign="center"
              fontSize="xs"
              fontWeight="extrabold"
              color="gray.700"
              textTransform="uppercase"
              bg="gray.50"
            >
              SVAs
            </Th>
          ) : null}
        </Tr>
      ) : null}
      <Tr borderBottom="2px solid" borderColor="gray.300">
        <Th
          fontSize="xs"
          color="gray.700"
          fontWeight="bold"
          textTransform="uppercase"
          textAlign="center"
          width="60px"
          bg="gray.50"
          py={3}
          borderColor="gray.200"
          position="sticky"
          left={0}
          zIndex={12}

        >
          ID
        </Th>
        <Th
          fontSize="xs"
          color="gray.700"
          fontWeight="bold"
          textTransform="uppercase"
          textAlign="left"
          width="250px"
          minW="250px"
          maxW="250px"
          bg="gray.50"
          py={3}
          position="sticky"
          left="50px"
          zIndex={12}
          borderRight="0px solid"
          borderColor="gray.200"
        >
          Nome do Plano
        </Th>
        {/* Valor do plano */}
        <Th
          fontSize="xs"
          color="gray.700"
          fontWeight="bold"
          textTransform="uppercase"
          textAlign="center"
          width="100px"
          minW="100px"
          maxW="100px"
          bg="gray.50"
          py={1}
          borderRight="0px solid"
          borderColor="gray.200"
          position="sticky"
          left="300px"
          zIndex={12}
        >
          <HStack spacing={3} justifyContent="center" alignItems="center">
            <Text fontSize="12px" fontWeight="bold">VALOR</Text>
            {setSortOrder && (
              <SortButton
                sortOrder={sortOrder}
                onSortChange={setSortOrder}
                label="Valor"
                tooltip={{
                  none: 'Ordenar por valor',
                  asc: 'Menor para maior',
                  desc: 'Maior para menor'
                }}
                size="md"
              />
            )}
          </HStack>
        </Th>
        <Th
          fontSize="xs"
          color="gray.700"
          fontWeight="bold"
          textTransform="uppercase"
          textAlign="center"
          width="120px"
          minW="120px"
          maxW="120px"
          bg="gray.50"
          py={3}
          borderRight="0px solid"
          borderColor="gray.200"
        >
          <VStack spacing={1}>
            <HStack spacing={2} alignItems="center" justifyContent="center">
              <Text
                fontSize="10px"
                fontWeight="bold"
                whiteSpace="normal"
                textAlign="start"
                wordBreak="break-word"
                maxW="90px"
                lineHeight="1.1"
              >
                USUÁRIOS ATIVOS
              </Text>
              {setClientsSortOrder && (
                <SortButton
                  sortOrder={clientsSortOrder}
                  onSortChange={setClientsSortOrder}
                  label="Usuários Ativos"
                  tooltip={{
                    none: 'Ordenar por usuários ativos',
                    asc: 'Menos para mais usuários',
                    desc: 'Mais para menos usuários'
                  }}
                  size="md"
                />
              )}
            </HStack>
          </VStack>
        </Th>
        {/* Agreements */}
        {children}
      </Tr>
    </Thead>
  );
};

export default HeaderTable;
